// extracted by mini-css-extract-plugin
module.exports = {"Advantages":"Advantages_Advantages__3UfKx","AdvantagesItem":"Advantages_AdvantagesItem__32oiX"};